import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { resolveAppBrowserTitle } from './appBrowserTitle';

/**
 * Keeps document.title in sync with the current route on EVERY screen — including
 * login / signup / app-picker (which live outside any workspace `<Admin>`). Inside a
 * workspace the tab shows that app's title; elsewhere it shows the company brand.
 *
 * Mount once at the router root. Favicon syncing stays in {@link SyncBrowserTitle}
 * because it is auth-gated and belongs to the authenticated workspace shell.
 */
export function BrowserTitleSync() {
    const { pathname } = useLocation();

    React.useEffect(() => {
        document.title = resolveAppBrowserTitle(pathname);
    }, [pathname]);

    return null;
}
